export default {
    data: [{
        key: 'extractDomain',
        name: 'Extract URL domain',
        function: "value.replace(/^(https?:\\/\\/)?(www\\.)?/, '').replace(/\\/$/, '')",
    }, {
        key: 'excelDate',
        name: 'Convert Excel numeric date to a Date object',
        function: 'FROM_DATE(value, EXCEL)',
    }, {
        key: 'getCoreCountries',
        name: 'Convert Countries',
        function: `const regions = RESOLVE(value, COUNTRIES, REGIONS_A, REGIONS_B);
            \nif (regions.includes('Global') || regions.length > 2) {\n    return ['Global'];\n}\nreturn regions;\n`,
    }, {
        key: 'getCoreIndustries',
        name: 'Convert industries',
        function: `const industries = RESOLVE(value, INDUSTRIES, INDUSTRY_GROUPS);\n
            if (industries.length > 3 || industries.includes('Diversified')) {\n
            return ['Generalist (without focus)'];\n}\nif (industries.length > 2) {\n
            return ['Multi-sector (few key sectors)'];\n}\nreturn industries;\n`,
    }, {
        key: 'getAllIndustries',
        name: 'Translate to all industries',
        function: "RESOLVE(value, INDUSTRIES, INDUSTRY_GROUPS).filter(val => val !== 'Diversified')",
    }, {
        key: 'translateCountry',
        name: 'Translate country',
        function: 'COUNTRIES[value] || value;',
    }, {
        key: 'translateRegionA',
        name: 'Translate region A',
        function: "REGIONS_A[value] || 'UNKNOWN';",
    }, {
        key: 'translateRegionB',
        name: 'Translate region B',
        function: "REGIONS_B[value] || 'UNKNOWN';",
    }, {
        key: 'translateCompany',
        name: "Translate Preqin's Company field",
        function: "COMPANIES[value] || 'UNKNOWN';",
    }],
}
